// Modules
import styled from "styled-components"

// Constants
import colors from "~constants/colors"

export const ControlSelectContainer = styled.div`
  display: flex;
  flex-direction: column;

  > .label {
    color: ${colors.gray4};
    display: block;
    letter-spacing: 0.76px;
    line-height: 100%;
    margin-bottom: 5px;
  }

  > .error-message {
    color: ${colors.red};
    display: block;
    font-size: 11px;
    height: 10px;
    letter-spacing: 0.21px;
    line-height: 10px;
    margin-top: 5px;
  }
`
